const paymentMethodsFR = {
    "view": {
        "table": {
            "title": "Votre liste de méthodes de paiement",
            "column": {
                "cardholder_name": "Nom du titulaire",
                "card_number": "Numéro de carte",
                "expiry_month": "Mois d'expiration",
                "expiry_year": "Année d'expiration",
                "type": "Type",
                "status": "Statut",
                "action": "Action"
            },
            "label": {
                "is_default": "Par défaut",
                "is_secondary": "Secondaire",
                "is_valid": "Valide",
                "is_expired": "Expiré",
                "not_available": "Non disponible",
                "month_january": "Janvier",
                "month_february": "Février",
                "month_march": "Mars",
                "month_april": "Avril",
                "month_may": "Mai",
                "month_june": "Juin",
                "month_july": "Juillet",
                "month_august": "Août",
                "month_september": "Septembre",
                "month_october": "Octobre",
                "month_november": "Novembre",
                "month_december": "Décembre"
            },
            "dropdown": {
                "action": "Action",
                "edit": "Modifier",
                "delete": "Supprimer"
            }
        },
        "message": {
            "maxPaymentMethodsLimitReached": "Vous avez atteint la limite de 3 méthodes de paiement. Si vous souhaitez en ajouter une nouvelle, vous pouvez le faire en supprimant une existante.",
            "success": "La méthode de paiement a été supprimée !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
        },
        "modal": {
            "delete": {
                "header": "Supprimer la méthode de paiement {{cardNumber}}",
                "body": "Êtes-vous sûr de vouloir supprimer cette méthode de paiement ?"
            }
        }
    },
    "add": {
        "title": "Ajouter une méthode de paiement",
        "form": {
            "label": {
                "card_details": "Détails de la carte",
                "cardholder_name": "Nom du titulaire",
                "card_number": "Numéro de carte",
                "expiry_month": "Mois d'expiration",
                "expiry_year": "Année d'expiration (AAAA)",
                "security_code_cvc": "Code de sécurité (CVC)",
                "billing_details": "Détails de facturation",
                "country": "Pays",
                "street_and_number": "Rue et numéro",
                "city": "Ville",
                "postal_code": "Code postal"
            },
            "help_text": {
                "security_code_cvc": "Le code de sécurité (CVC) de votre carte est le numéro à 3 ou 4 chiffres situé au dos de la plupart des cartes."
            },
            "options": {
                "month": {
                    "january": "Janvier",
                    "february": "Février",
                    "march": "Mars",
                    "april": "Avril",
                    "may": "Mai",
                    "june": "Juin",
                    "july": "Juillet",
                    "august": "Août",
                    "september": "Septembre",
                    "october": "Octobre",
                    "november": "Novembre",
                    "december": "Décembre"
                },
                "expiry_month": {
                    "select": "Sélectionner le mois d'expiration"
                },
                "country": {
                    "select": "Sélectionner le pays"
                }
            },
            "button": {
                "submit": "Soumettre"
            },
            "validation": {
                "expiry_month_required": "Le mois d'expiration est requis",
                "expiry_month_valid": "Le mois d'expiration ne doit pas être dans le passé",
                "country_required": "Le pays est requis"
            }
        },
        "message": {
            "success": "La méthode de paiement a été ajoutée !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
        },
        "modal": {
            "addPaymentMethod": {
                "header": "Êtes-vous sûr de vouloir ajouter cette méthode de paiement à votre profil ?",
                "body": "Par la présente, vous garantissez que toutes les données fournies sont véridiques. Vous êtes seul et légalement responsable des données fournies et de la véracité de ces informations.",
                "button": {
                    "cancel": "Annuler",
                    "confirm": "Confirmer"
                }
            }
        }
    },
    "update": {
        "title": "Mettre à jour la méthode de paiement",
        "form": {
            "label": {
                "card_details": "Détails de la carte",
                "cardholder_name": "Nom du titulaire",
                "card_number": "Numéro de carte",
                "expiry_month": "Mois d'expiration",
                "expiry_year": "Année d'expiration (AAAA)",
                "security_code_cvc": "Code de sécurité (CVC)",
                "billing_details": "Détails de facturation",
                "country": "Pays",
                "street_and_number": "Rue et numéro",
                "city": "Ville",
                "postal_code": "Code postal",
                "set_as_default": "Définir par défaut"
            },
            "help_text": {
                "security_code_cvc": "Le code de sécurité (CVC) de votre carte est le numéro à 3 ou 4 chiffres situé au dos de la plupart des cartes."
            },
            "options": {
                "month": {
                    "january": "Janvier",
                    "february": "Février",
                    "march": "Mars",
                    "april": "Avril",
                    "may": "Mai",
                    "june": "Juin",
                    "july": "Juillet",
                    "august": "Août",
                    "september": "Septembre",
                    "october": "Octobre",
                    "november": "Novembre",
                    "december": "Décembre"
                },
                "expiry_month": {
                    "select": "Sélectionner le mois d'expiration"
                },
                "country": {
                    "select": "Sélectionner le pays"
                }
            },
            "button": {
                "submit": "Soumettre"
            },
            "validation": {
                "expiry_month_required": "Le mois d'expiration est requis",
                "expiry_month_valid": "Le mois d'expiration ne doit pas être dans le passé",
                "country_required": "Le pays est requis"
            }
        },
        "message": {
            "success": "La méthode de paiement a été mise à jour !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
        },
        "modal": {
            "updatePaymentMethod": {
                "header": "Êtes-vous sûr de vouloir mettre à jour votre méthode de paiement ?",
                "body": "Par la présente, vous garantissez que toutes les données fournies sont véridiques. Vous êtes seul et légalement responsable des données fournies et de la véracité de ces informations.",
                "button": {
                    "cancel": "Annuler",
                    "confirm": "Confirmer"
                }
            }
        }
    }
};

export default paymentMethodsFR;